import { assert } from '@ember/debug';

import FlashMessages from 'ember-cli-flash/services/flash-messages';

import Toast from 'register-partners-js/components/toast';

export default class ToastFlashMessagesService extends FlashMessages {
  // subclassing ember-cli-flash method
  clearMessages() {
    super.clearMessages();
  }

  /**
   * Triggers an info toast.
   *
   * @param {string} message - The message to display to the user.
   *
   * @returns {undefined}
   */
  toastInfo(message) {
    assert('A flashMessage must have a message', message);

    this.add({
      componentKind: 'toast',
      componentName: Toast,
      type: 'info',
      priority: 101,
      message,
    });
  }

  /**
   * Triggers a success toast.
   *
   * @param {string} message - The message to display to the user.
   *
   * @returns {undefined}
   */
  toastSuccess(message) {
    assert('A flashMessage must have a message', message);

    this.add({
      componentKind: 'toast',
      componentName: Toast,
      type: 'success',
      priority: 100,
      message,
    });
  }

  /**
   * Triggers a success toast.
   *
   * @param {string} message - The message to display to the user.
   *
   * @returns {undefined}
   */
  toastError(message) {
    assert('A flashMessage must have a message', message);

    this.add({
      componentKind: 'toast',
      componentName: Toast,
      type: 'error',
      priority: 102,
      message,
    });
  }
}
